import { render } from "./SponsorManageCreateForm.vue?vue&type=template&id=7ff98c8f&lang=true"
import script from "./SponsorManageCreateForm.vue?vue&type=script&lang=js"
export * from "./SponsorManageCreateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__